/**
 * Pure logic for the Change User page (legacy Delphi "Schimbare utilizator").
 *
 * The page lets the operator at a workstation hand the running session over to another
 * staff member (or re-confirm themselves) by picking a user and entering that user's password,
 * without going through a full logout.
 */

/** Route of the Change User page; mirrors the legacy `Schutil` menu button key. */
export const CHANGE_USER_PATH = '/schutil';

/** Shape of a row returned by `GET /api/users`, reduced to what the page needs. */
export interface ChangeUserCandidate {
    username: string;
    isActive: boolean;
}

/**
 * Usernames that can be selected on the Change User page: active accounts only, blank
 * names dropped, duplicates removed, sorted case-insensitively for a stable dropdown.
 */
export function listSwitchableUsernames(users: readonly ChangeUserCandidate[]): string[] {
    const usernames = new Set<string>();
    for (const user of users) {
        const username = user.username.trim();
        if (user.isActive && username.length > 0) {
            usernames.add(username);
        }
    }
    return [...usernames].sort((left, right) =>
        left.localeCompare(right, undefined, { sensitivity: 'base' }),
    );
}

/**
 * The username the form starts with: the signed-in user when they are still selectable
 * (the legacy screen doubled as "confirm user"), otherwise nothing.
 */
export function resolveInitialUsername(
    switchableUsernames: readonly string[],
    currentUsername: string | undefined,
): string | undefined {
    if (currentUsername === undefined) {
        return undefined;
    }
    return switchableUsernames.includes(currentUsername) ? currentUsername : undefined;
}
